import React from 'react';
import {
  FaBolt,
  FaBriefcase,
  FaChartLine,
  FaCloud,
  FaCode,
  FaDatabase,
  FaFileAlt,
  FaGlobe,
  FaImage,
  FaLaptopCode,
  FaLayerGroup,
  FaMobileAlt,
  FaPaintBrush,
  FaPalette,
  FaPlug,
  FaQuestionCircle,
  FaRocket,
  FaShieldAlt,
  FaTools,
  FaUserCog,
  FaUsers,
  FaWordpress,
} from 'react-icons/fa';

export const SERVICE_ICONS = {
  FaBolt,
  FaBriefcase,
  FaChartLine,
  FaCloud,
  FaCode,
  FaDatabase,
  FaFileAlt,
  FaGlobe,
  FaImage,
  FaLaptopCode,
  FaLayerGroup,
  FaMobileAlt,
  FaPaintBrush,
  FaPalette,
  FaPlug,
  FaQuestionCircle,
  FaRocket,
  FaShieldAlt,
  FaTools,
  FaUserCog,
  FaUsers,
  FaWordpress,
};

export const SERVICE_ICON_OPTIONS = [
  ['FaLaptopCode', 'طراحی وب‌سایت'],
  ['FaPaintBrush', 'طراحی و گرافیک'],
  ['FaLayerGroup', 'رابط کاربری'],
  ['FaPlug', 'افزونه'],
  ['FaWordpress', 'وردپرس'],
  ['FaCode', 'کدنویسی'],
  ['FaBriefcase', 'خدمات'],
  ['FaPalette', 'رنگ و برند'],
  ['FaMobileAlt', 'موبایل'],
  ['FaRocket', 'راه‌اندازی'],
  ['FaShieldAlt', 'امنیت'],
  ['FaTools', 'پشتیبانی'],
  ['FaQuestionCircle', 'راهنما'],
  ['FaFileAlt', 'مستندات'],
  ['FaGlobe', 'وب'],
  ['FaDatabase', 'دیتابیس'],
  ['FaBolt', 'سرعت'],
  ['FaUsers', 'کاربران'],
];

export const getServiceIcon = (name) => SERVICE_ICONS[name] || FaBriefcase;

const ServiceIcon = ({ name, ...props }) => {
  const Icon = getServiceIcon(name);
  return <Icon {...props} />;
};

export default ServiceIcon;
